import { useEffect } from 'react';

const INACTIVITY_THRESHOLD = 60 * 60 * 1000; // 1 hour
const LAST_ACTIVE_TIME_KEY = 'dpdonline-lastActiveTime';

const useAutoReloadOnInactivity = () => {
  useEffect(() => {
    // Initialize the last active time on mount
    localStorage.setItem(LAST_ACTIVE_TIME_KEY, String(Date.now()));

    const updateLastActive = () => {
      const lastActive =
        Number(localStorage.getItem(LAST_ACTIVE_TIME_KEY)) || Date.now();

      // Check if the inactivity threshold is exceeded
      if (Date.now() - lastActive > INACTIVITY_THRESHOLD) {
        localStorage.removeItem(LAST_ACTIVE_TIME_KEY); // Cleanup before reload
        window.location.reload();
      }

      // Update timestamp only if page is still active
      localStorage.setItem(LAST_ACTIVE_TIME_KEY, String(Date.now()));
    };

    const clearLastActive = () => {
      localStorage.removeItem(LAST_ACTIVE_TIME_KEY);
    };

    // Track visibility and focus changes
    document.addEventListener('visibilitychange', updateLastActive);
    window.addEventListener('focus', updateLastActive);

    // Remove timestamp when page unloads (e.g., user closes the tab)
    window.addEventListener('beforeunload', clearLastActive);

    return () => {
      document.removeEventListener('visibilitychange', updateLastActive);
      window.removeEventListener('focus', updateLastActive);
      window.removeEventListener('beforeunload', clearLastActive);
    };
  }, []);
};

export default useAutoReloadOnInactivity;
